import React from "react";
import { Link, useParams } from "react-router-dom";
import RentedHouseForm from "../../../../components/forms/RentedHouseForm";
import HomeLoanForm from "../../../../components/forms/HomeLoanForm";
import RentalIncomeForm from "../../../../components/forms/RentalIncomeForm";
import OtherSourcesIncomeForm from "../../../../components/forms/OtherSourcesIncomeForm";
import InvestmentsForm from "../../../../components/forms/InvestmentsForm";
import ExemptionsForm from "../../../../components/forms/ExemptionsForm";
import OtherInvestmentsExemptionsForm from "../../../../components/forms/OtherInvestmentsExemptionsForm";
import useTdsProofOfInvestments from "../../../../hooks/useTdsProofOfInvestments";
import PrimaryLoader from "../../../../components/common/PrimaryLoader";

const EditProofOfInvestments = () => {
  const { company_employee_id } = useParams();
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    onSubmit,
    isSubmitting,
    isDataLoaded,
    existingData,
  } = useTdsProofOfInvestments();

  if (!isDataLoaded) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <PrimaryLoader />
      </div>
    );
  }

  const regime =
    existingData?.main_submission_data?.employee_regime_selection?.regime || "old";
  const regimeLabel = regime === "old" ? "Old Tax Regime" : "New Tax Regime";

  return (
    <div className="p-6 mt-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">
          Proof of Investments
        </h1>
        <div className="text-gray-600 text-sm">
          <span className="font-medium">Tax Regime :</span> {regimeLabel}
        </div>
      </div>

      <div className="sticky top-16 z-10 bg-white border-b border-gray-200 mb-6 shadow-sm">
        <div className="flex items-center justify-between py-4 pl-6">
          <div className="flex w-full">
            <div className="w-1/3 text-sm font-semibold text-gray-700 uppercase tracking-wider">
              PARTICULARS
            </div>
            <div className="w-1/3 text-sm font-semibold text-gray-700 uppercase tracking-wider text-center">
              DECLARED AMOUNT
            </div>
            <div className="w-1/3 text-sm font-semibold text-gray-700 uppercase tracking-wider text-center">
              ACTUAL AMOUNT
            </div>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        {/* Show all forms for old regime, only specific ones for new regime */}
        {regime === "old" && (
          <>
            {/* Rented House Form - now with POI mode */}
            <RentedHouseForm
              control={control}
              watch={watch}
              setValue={setValue}
              isPOI={true}
            />

            {/* Home Loan Form - now with POI mode */}
            <HomeLoanForm control={control} watch={watch} isPOI={true} />
          </>
        )}

        {/* Rental Income Form - shown for both regimes but with different calculations */}
        <RentalIncomeForm
          control={control}
          watch={watch}
          setValue={setValue}
          isPOI={true}
          regime={regime}
        />

        {/* Other Sources of Income Form - shown for both regimes */}
        <OtherSourcesIncomeForm control={control} isPOI={true} />

        {/* Show investment forms only for old regime */}
        {regime === "old" && (
          <>
            {/* 80C Investments Form - now with POI mode */}
            <InvestmentsForm control={control} isPOI={true} />
            {/* 80D Exemptions Form - now with POI mode */}
            <ExemptionsForm control={control} isPOI={true} />
            {/* Other Investments & Exemptions Form - now with POI mode */}
            <OtherInvestmentsExemptionsForm control={control} isPOI={true} />
          </>
        )}

        {/* Action Buttons */}
        <div className="flex items-center justify-between pt-6">
          <div className="flex gap-4">
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-6 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors disabled:bg-blue-400 disabled:cursor-not-allowed flex items-center gap-2"
            >
              {isSubmitting && (
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              )}
              {isSubmitting ? "Saving..." : "Save & Continue"}
            </button>
            <Link
              to={`/employee-details/${company_employee_id}/investments-and-proofs?tab=poi`}
              className="px-6 py-2 border border-gray-300 text-gray-700 font-medium rounded-md hover:bg-gray-50 transition-colors"
            >
              Cancel
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EditProofOfInvestments;